'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * FieldSet with a legend label
 */
ngModule.directive("fieldSet", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      label: "@"
    },
    template: '' + '<div class="fieldset">' + '   <div ng-if="label" class="tl-legend">' + '       {{label | translate}}' + '   </div>' + '   <div class="content" ng-transclude></div>' + '</div>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/fieldSet.js
// module id = 2943
// module chunks = 13